import { render, staticRenderFns } from "./allocationMaterialDetail.vue?vue&type=template&id=5b923944&scoped=true"
import script from "./allocationMaterialDetail.vue?vue&type=script&lang=js"
export * from "./allocationMaterialDetail.vue?vue&type=script&lang=js"
import style0 from "./allocationMaterialDetail.vue?vue&type=style&index=0&id=5b923944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b923944",
  null
  
)

export default component.exports